import endpoint from "../../config/endpoints";

export const ReplicaTransactionJson = {
    showSaveNextBtn: false,
    apiBaseURL: endpoint.stackholder,
    screenTitle: "Order Replica Transaction",
    screenTitleForBillReplica: "Bill Replica Transaction",
    searchButtonGrid: 1,
    showAddButton: false,
    showDeleteIcon: false,
    showPdfDownload: false,
    pdfFileName: "Stock Holder",
    showExcelDownload: false,


    fieldMeta: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "todate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "toDate",
            onSubmit: "compare",
            onSubmitParameter: "fromdate-ge",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "fromdate-ge",
        },
    ],
};
